﻿/*-------------------------------------------------------
'   @module: HK - Article Informations
'---------------------------------------------------------*/

export class HKArtInfo {
    constructor() {
        this.gallery = document.querySelector('.image-gallery');
        this.articleInfo = document.querySelector('.article-informations');
        this.showMoreContainer = document.querySelector('.article-information-showmore');
        this.defaultMaxHeight = null;

        if (this.gallery && this.articleInfo && this.showMoreContainer) {
            this.getDefaultMaxHeight();
            this.adjustArtInfoHeight();
            this.attachArtInfoEventListener();
        }
    }

    /**
     * Adjust height of article information container on desktop
     */
    adjustArtInfoHeight() {
        if (window.innerWidth >= 800) {
            let galleryHeight = this.gallery.offsetHeight;
            let showLessButtonElement = this.showMoreContainer.querySelector('[data-op-action="show-less"]');
            let onShowLessClicked = !showLessButtonElement.classList.contains("is-hidden");
            let currentHeight = onShowLessClicked ? this.defaultMaxHeight : galleryHeight;
            this.articleInfo.style.maxHeight = `${currentHeight}px`;

            if(onShowLessClicked){
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }

            if (parseInt(this.articleInfo.style.maxHeight) > this.articleInfo.offsetHeight) {
                this.showMoreContainer.classList.add("is-hidden");
            } else {
                this.showMoreContainer.classList.remove("is-hidden");
            }
        } else {
            this.articleInfo.style.maxHeight = "fit-content";
            this.showMoreContainer.classList.add("is-hidden");
        }
    }

    /**
     * Attach event listeners for window-resize and click on "show more"-actions
     */
    attachArtInfoEventListener() {
        window.addEventListener("resize", e => {
            this.adjustArtInfoHeight();
        });

        this.showMoreContainer.addEventListener("click", e => {
            if (e.target.closest('[data-op-action="show-more"]')) {
                this.articleInfo.style.maxHeight = "fit-content";
                this.toggleHiddenCildren(this.showMoreContainer);
            }
            if (e.target.closest('[data-op-action="show-less"]')) {
                this.adjustArtInfoHeight();
                this.toggleHiddenCildren(this.showMoreContainer);
            }
        });
    }

    /**
     * Toggle "is-hidden"-class on children of a container
     * @param {Object} container container node
     */
    toggleHiddenCildren(container) {
        for (const child of container.children) {
            child.classList.toggle("is-hidden");
        }
    }

    /**
     * Get the inital height of the article info area (".article-informations")
     */
    getDefaultMaxHeight(){
        this.defaultMaxHeight = this.gallery.offsetHeight;
    }
}

new HKArtInfo();